module.exports = "/_next/static/images/MultichannelMessaging-537218be7d45c077a672f762ee220746.webp";